import CurrencyCell from "../components/CurrencyCell";
import { cellStyle, currencyFormat } from "../helpers";
import { golmAggFunc } from "../helpers/summaryData";

export const currentSummaryColDef = (monthYear, type) => {
  const daysInMonth = monthYear.daysInMonth();
  const daysInPreviousMonth = monthYear.subtract(1, "month").daysInMonth();
  return [
    {
      headerName: "",
      headerClass: "primary",
      children: [
        {
          field: "id",
          hide: true,
        },
        {
          headerClass: "primary",
          colId: "Region",
          field: "Region",
          width: 130,
          enableRowGroup: true,
          enablePivot: true,
          pinned: true,
          filter: "text",
          rowGroup: true,
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerClass: "primary",
          colId: "Country",
          field: "Country",
          width: 130,
          enableRowGroup: true,
          enablePivot: true,
          pinned: true,
          filter: "text",
          rowGroup: true,
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerClass: "primary",
          colId: "Warehouse",
          field: "Warehouse",
          width: 130,
          enableRowGroup: true,
          enablePivot: true,
          pinned: true,
          editable: true,
          filter: "text",
          rowGroup: true,
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerName: "Channel",
          headerClass: "primary",
          colId: "OutletType",
          field: "OutletType",
          width: 120,
          enableRowGroup: true,
          enablePivot: true,
          pinned: false,
          editable: true,
          filter: "text",
          // rowGroup: true,
          cellRenderer: "agGroupCellRenderer",
        },

        {
          headerClass: "primary",
          field: "Pricelist",
          width: 175,
          enableRowGroup: true,
          pinned: false,
          enablePivot: true,
          filter: "text",
          // rowGroup: true,
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerClass: "primary",
          headerName: "Category",
          field: "Category",
          width: 120,
          enableRowGroup: true,
          pinned: false,
          enablePivot: true,
          filter: "text",
          // rowGroup: true,
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerClass: "primary",
          headerName: "Product",
          colId: "Product_Name",
          field: "Product_Name",
          width: 120,
          enableRowGroup: true,
          pinned: false,
          enablePivot: true,
          filter: "text",
          // rowGroup: true,
          cellRenderer: "agGroupCellRenderer",
        },
        {
          headerClass: "primary",
          field: "ProductCode",
          width: 120,
          enableRowGroup: true,
          enablePivot: true,
          filter: "text",
          hide: true,
        },
      ],
    },
    {
      headerName: "",
      headerClass: "primary",
      children: [
        {
          headerName: "",
          headerClass: "primary",
          children: [
            {
              headerName: monthYear.subtract(2, "month").format("MMMM"),
              headerClass: "primary",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "M2",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "M2_quantity",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
            {
              headerName: monthYear.subtract(1, "month").format("MMMM"),
              headerClass: "primary",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "M1",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "M1_quantity",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
            {
              headerName: "AOP",
              headerClass: "primary",
              children: [
                {
                  headerClass: "primary",
                  headerName: "AOP",
                  field: "AOP_Figure",
                  width: 120,
                  enablePivot: true,
                  cellRenderer: CurrencyCell,
                  aggFunc: "sum",
                  enableValue: true,
                  valueGetter: (params) => {
                    return parseInt(params?.data?.AOP_Figure);
                  },
                  valueFormatter: (params) => currencyFormat(params.value),
                  // cellRenderer: CurrencyCell,
                  type: "rightAligned",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      headerName: "MTD",
      headerClass: "primary",
      cellStyle: { textAlign: "center" },
      children: [
        {
          headerName: "Plan",
          headerClass: "primary",
          cellStyle: { textAlign: "center" },
          children: [
            {
              headerName: "Baseline",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "mtd_baseline",
                  width: 120,
                  enablePivot: true,
                  // aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "mtd_baseline_quantity",
                  width: 120,
                  enablePivot: true,
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
            {
              headerName: "Corection",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "mtd_correction",
                  width: 120,
                  enablePivot: true,
                  // aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "mtd_correction_quantity",
                  width: 120,
                  enablePivot: true,
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
            {
              headerName: "On Inv",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "mtd_oninv",
                  width: 120,
                  // aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enablePivot: true,
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "mtd_oninv_quantity",
                  width: 120,
                  enablePivot: true,
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
            {
              headerName: "Off Inv",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "mtd_offinv",
                  width: 120,
                  // aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enablePivot: true,
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "mtd_offinv_quantity",
                  width: 120,
                  enablePivot: true,
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
            {
              headerName: "Target",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "mtd_target",
                  width: 120,
                  // aggFunc: "sum",
                  type: "rightAligned",
                  cellRenderer: CurrencyCell,
                  enablePivot: true,
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "mtd_target_quantity",
                  width: 120,
                  enablePivot: true,
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
          ],
        },
        {
          headerName: "Actual",
          headerClass: "primary",
          cellStyle: { textAlign: "center" },
          enablePivot: true,
          children: [
            {
              headerName: "Actual",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "mtd_actual",
                  width: 120,
                  // aggFunc: "sum",
                  type: "rightAligned",
                  cellRenderer: CurrencyCell,
                  enablePivot: true,
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "mtd_actual_quantity",
                  width: 120,
                  enablePivot: true,
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
          ],
        },
      ],
    },

    {
      headerName: "BTG",
      headerClass: "primary",
      cellStyle: { textAlign: "center" },
      children: [
        {
          headerName: "Plan",
          headerClass: "primary",
          cellStyle: { textAlign: "center" },
          children: [
            {
              headerName: "Baseline",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
            {
              headerClass: "primary",
              headerName: "Rev",
              field: "btg_baseline",
              width: 120,
              enablePivot: true,
              // aggFunc: "sum",
              cellRenderer: CurrencyCell,
              type: "rightAligned",
              sort: "desc",
              enableValue: true,
            },
            {
              headerClass: "primary",
              headerName: " Qty",
              field: "btg_baseline_quantity",
              width: 120,
              enablePivot: true,
              //...(type === "Quantity" && { aggFunc: "sum" }),
              cellRenderer: CurrencyCell,
              type: "rightAligned",
              enableValue: true,
            } 
              ]
            },
            {
              headerName: "Correction",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "btg_correction",
                  width: 120,
                  enablePivot: true,
                  // aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "btg_correction_quantity",
                  width: 120,
                  enablePivot: true,
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                }]
            },
            {
              headerName: "On Inv",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
            {
              headerClass: "primary",
              headerName: "Rev",
              field: "btg_oninv",
              width: 120,
              // aggFunc: "sum",
              cellRenderer: CurrencyCell,
              type: "rightAligned",
              enablePivot: true,
              enableValue: true,
            },
            {
              headerClass: "primary",
              headerName: "Qty",
              field: "btg_oninv_quantity",
              width: 120,
              //...(type === "Quantity" && { aggFunc: "sum" }),
              cellRenderer: CurrencyCell,
              type: "rightAligned",
              enablePivot: true,
              enableValue: true,
            }],
          },
          {
            headerName: "On Off",
            headerClass: "primary",
            cellStyle: { textAlign: "center" },
            children: [
            {
              headerClass: "primary",
              headerName: "Inv",
              field: "btg_offinv",
              width: 120,
              // aggFunc: "sum",
              cellRenderer: CurrencyCell,
              type: "rightAligned",
              enablePivot: true,
              enableValue: true,
            },
            {
              headerClass: "primary",
              headerName: "Qty",
              field: "btg_offinv_quantity",
              width: 120,
              //...(type === "Quantity" && { aggFunc: "sum" }),
              cellRenderer: CurrencyCell,
              type: "rightAligned",
              enablePivot: true,
              enableValue: true,
            }]
          },
          {
            headerName: "Plan",
            headerClass: "primary",
            cellStyle: { textAlign: "center" },
            children: [
            {
              headerClass: "primary",
              headerName: "Rev",
              field: "btg_plan",
              width: 120,
              // aggFunc: "sum",
              type: "rightAligned",
              cellRenderer: CurrencyCell,
              enablePivot: true,
              enableValue: true,
            },
            {
              headerClass: "primary",
              headerName: "Qty",
              field: "btg_plan_quantity",
              width: 120,
              //...(type === "Quantity" && { aggFunc: "sum" }),
              type: "rightAligned",
              cellRenderer: CurrencyCell,
              enablePivot: true,
              enableValue: true,
            },
          ]}
          ],
        },
        {
          headerName: "Current Plan",
          headerClass: "primary",
          cellStyle: { textAlign: "center" },
          children: [
        {
          headerClass: "primary",
          headerName: "Rev",
          field: "btg_target",
          width: 120,
          // aggFunc: "sum",
          type: "rightAligned",
          cellRenderer: CurrencyCell,
          enablePivot: true,
          enableValue: true,
        },
        {
          headerClass: "primary",
          headerName: "Qty",
          field: "btg_target_quantity",
          width: 120,
          //...(type === "Quantity" && { aggFunc: "sum" }),
          type: "rightAligned",
          cellRenderer: CurrencyCell,
          enablePivot: true,
          enableValue: true,
        },
      ]}
      ],
    },

    {
      headerName: "Full Month",
      headerClass: "primary",
      cellStyle: { textAlign: "center" },
      children: [
        {
          headerName: "",
          headerClass: "primary",
          cellStyle: { textAlign: "center" },
          children: [
            {
              headerName: "Month Target",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "month_target",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "month_target_quantity",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
            {
              headerName: "Outlook",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  headerName: "Rev",
                  field: "month_outlook",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                {
                  headerClass: "primary",
                  headerName: "Qty",
                  field: "month_outlook_quantity",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  //...(type === "Quantity" && { aggFunc: "sum" }),
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              ],
            },
          ],
        },
      ],
    },
    {
      headerName: "",
      headerClass: "primary",
      cellStyle: { textAlign: "center" },
      children: [
        {
          headerName: "",
          headerClass: "primary",
          cellStyle: { textAlign: "center" },
          children: [
            {
              headerName: "GOLM %",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerName: "Rev",
                  colId: "golmCol",
                  headerClass: "primary",
                  // filter: "text",
                  type: "rightAligned",
                  width: 120,
                  enablePivot: true,
                  enableValue: true,
                  valueGetter: (params) => {
                    if (!params.node.group) {
                      const monthOutlookAvg =
                        params.data.month_outlook / daysInMonth;
                      const M1Avg = params.data.M1 / daysInPreviousMonth;
                      const golm = ((monthOutlookAvg - M1Avg) / M1Avg) * 100;
                      return {
                        month_outlook: params.data.month_outlook,
                        M1: params.data.M1,
                        toString: () =>
                          !isNaN(golm) && isFinite(golm) ? Math.round(golm) : 0,
                      };
                    }
                  },
                  valueFormatter: (params) =>
                    params.value !== 0 ? params.value + "%" : "",
                  aggFunc: (params) => {
                    var m1Aggr = 0;
                    var MAggr = 0;
                    params.values.forEach((value) => {
                      if (value && value.M1) {
                        m1Aggr += value.M1;
                      }
                      if (value && value.month_outlook) {
                        MAggr += value.month_outlook;
                      }
                    });
                    const MAggrAvg = MAggr / daysInMonth;
                    const m1AggrAvg = m1Aggr / daysInPreviousMonth;
                    const golm = ((MAggrAvg - m1AggrAvg) / m1AggrAvg) * 100;
                    return {
                      month_outlook: MAggr,
                      M1: m1Aggr,
                      golmValue: golm,
                      toString: () => {
                        return m1Aggr && MAggr
                          ? Math.round(
                              ((MAggrAvg - m1AggrAvg) / m1AggrAvg) * 100
                            )
                          : 0;
                      },
                    };
                  },
                  cellStyle: (params) => {
                    return cellStyle(params);
                  },
                },
                {
                  headerName: "Qty",
                  colId: "golmCol",
                  headerClass: "primary",
                  // filter: "text",
                  type: "rightAligned",
                  width: 120,
                  enablePivot: true,
                  enableValue: true,
                  valueGetter: (params) => {
                    if (!params.node.group) {
                      const monthOutlookAvg =
                        params.data.month_outlook_quantity / daysInMonth;
                      const M1Avg =
                        params.data.M1_quantity / daysInPreviousMonth;
                      const golm = ((monthOutlookAvg - M1Avg) / M1Avg) * 100;
                      return {
                        month_outlook_quantity:
                          params.data.month_outlook_quantity,
                        M1_quantity: params.data.M1_quantity,
                        toString: () =>
                          !isNaN(golm) && isFinite(golm) ? Math.round(golm) : 0,
                      };
                    }
                  },
                  valueFormatter: (params) =>
                    params.value !== 0 ? params.value + "%" : "",
                  aggFunc: (params) => {
                    var m1Aggr = 0;
                    var MAggr = 0;
                    params.values.forEach((value) => {
                      if (value && value.M1_quantity) {
                        m1Aggr += value.M1_quantity;
                      }
                      if (value && value.month_outlook_quantity) {
                        MAggr += value.month_outlook_quantity;
                      }
                    });
                    const MAggrAvg = MAggr / daysInMonth;
                    const m1AggrAvg = m1Aggr / daysInPreviousMonth;
                    return {
                      month_outlook_quantity: MAggr,
                      M1_quantity: m1Aggr,
                      toString: () => {
                        return m1Aggr && MAggr
                          ? Math.round(
                              ((MAggrAvg - m1AggrAvg) / m1AggrAvg) * 100
                            )
                          : 0;
                      },
                    };
                  },
                },
              ],
            },
            {
              headerName: "GOLY %",
              headerClass: "primary",
              cellStyle: { textAlign: "center" },
              children: [
                {
                  headerClass: "primary",
                  colId: "golyCol",
                  field: "Rev",
                  width: 120,
                  // filter: "text",
                  enablePivot: true,
                  type: "rightAligned",
                  enableValue: true,
                  valueGetter: (params) => {
                    if (!params.node.group) {
                      const golm =
                        ((params.data.month_outlook -
                          params.data.LastYearActual) /
                          params.data.LastYearActual) *
                        100;
                      return {
                        month_outlook: params.data.month_outlook,
                        LastYearActual: params.data.LastYearActual,
                        toString: () =>
                          !isNaN(golm) && isFinite(golm) ? Math.round(golm) : 0,
                      };
                    }
                  },
                  valueFormatter: (params) =>
                    params.value !== 0 ? params.value + "%" : "",
                  aggFunc: (params) => {
                    var m1Aggr = 0;
                    var MAggr = 0;
                    params.values.forEach((value) => {
                      if (value && value.LastYearActual) {
                        m1Aggr += value.LastYearActual;
                      }
                      if (value && value.month_outlook) {
                        MAggr += value.month_outlook;
                      }
                    });
                    return {
                      month_outlook: MAggr,
                      LastYearActual: m1Aggr,
                      toString: () => {
                        return m1Aggr && MAggr
                          ? Math.round(((MAggr - m1Aggr) / m1Aggr) * 100)
                          : 0;
                      },
                    };
                  },
                },
                {
                  headerClass: "primary",
                  colId: "golyCol",
                  field: "Qty",
                  width: 120,
                  // filter: "text",
                  enablePivot: true,
                  type: "rightAligned",
                  enableValue: true,
                  valueGetter: (params) => {
                    if (!params.node.group) {
                      const golm =
                        ((params.data.month_outlook_quantity -
                          params.data.LastYearActual_Quantity) /
                          params.data.LastYearActual_Quantity) *
                        100;
                      return {
                        month_outlook_quantity:
                          params.data.month_outlook_quantity,
                        LastYearActual_Quantity:
                          params.data.LastYearActual_Quantity,
                        toString: () =>
                          !isNaN(golm) && isFinite(golm) ? Math.round(golm) : 0,
                      };
                    }
                  },
                  valueFormatter: (params) =>
                    params.value !== 0 ? params.value + "%" : "",
                  aggFunc: (params) => {
                    var m1Aggr = 0;
                    var MAggr = 0;
                    params.values.forEach((value) => {
                      if (value && value.LastYearActual_Quantity) {
                        m1Aggr += value.LastYearActual_Quantity;
                      }
                      if (value && value.month_outlook_quantity) {
                        MAggr += value.month_outlook_quantity;
                      }
                    });
                    return {
                      month_outlook_quantity: MAggr,
                      LastYearActual_Quantity: m1Aggr,
                      toString: () => {
                        return m1Aggr && MAggr
                          ? Math.round(((MAggr - m1Aggr) / m1Aggr) * 100)
                          : 0;
                      },
                    };
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    {
      headerName: "",
      headerClass: "primary",
      cellStyle: { textAlign: "center" },
      children: [
        {
          headerClass: "primary",
          headerName: "M Discount Cost Plan",
          children: [
            {
              headerClass: "primary",
              headerName: "On Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M Discount OnInv Plan",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M Discount OnInv Plan Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Off Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M Discount OffInv Plan",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M Discount OffInv Plan Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Visibility",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M Discount Visibility Plan",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M Discount Visibility Plan Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
          ],
        },

        {
          headerClass: "primary",
          headerName: " M Discount Cost Actual",
          children: [
            {
              headerClass: "primary",
              headerName: "On Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M Discount OnInv Act",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              //   {
              //     headerClass: "primary",
              //     headerName: "Qty",
              //     field: "M Discount OnInv Act Quantity",
              //     width: 120,
              //     enablePivot: true,
              //     aggFunc: "sum",
              //     //...(type === "Quantity" && { aggFunc: "sum" }),
              //     cellRenderer: CurrencyCell,
              //     type: "rightAligned",
              //     enableValue: true,
              //   },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Off Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M Discount OffInv Act",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M Discount OffInv Act Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Visibility",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M Discount Visibility Act",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M Discount Visibility Act Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
          ],
        },
        {
          headerName: "M-1 Discount Cost Plan",
          headerClass: "primary",
          children: [
            {
              headerClass: "primary",
              headerName: "On Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M-1 Discount OnInv Plan",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M-1 Discount OnInv Plan Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Off Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M-1 Discount OffInv Plan",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M-1 Discount OffInv Plan Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Visibility",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M-1 Discount Visibility Plan",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              //   {
              //     headerClass: "primary",
              //     headerName: "Qty",
              //     field: "M-1 Discount Visibility Plan Quantity",
              //     width: 120,
              //     enablePivot: true,
              //     aggFunc: "sum",
              //     //...(type === "Quantity" && { aggFunc: "sum" }),
              //     cellRenderer: CurrencyCell,
              //     type: "rightAligned",
              //     enableValue: true,
              //   },
              ],
            },
          ],
        },
        {
          headerName: "M-1 Discount Cost Actual",
          headerClass: "primary",
          children: [
            {
              headerClass: "primary",
              headerName: "On Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M-1 Discount OnInv Act",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M-1 Discount OnInv Act Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Off Inv",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M-1 Discount OffInv Act",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
                // {
                //   headerClass: "primary",
                //   headerName: "Qty",
                //   field: "M-1 Discount OffInv Act Quantity",
                //   width: 120,
                //   enablePivot: true,
                //   aggFunc: "sum",
                //   //...(type === "Quantity" && { aggFunc: "sum" }),
                //   cellRenderer: CurrencyCell,
                //   type: "rightAligned",
                //   enableValue: true,
                // },
              ],
            },
            {
              headerClass: "primary",
              headerName: "Visibility",
              children: [
                {
                  headerClass: "primary",
                  headerName: "Cost",
                  field: "M-1 Discount Visibility Act",
                  width: 120,
                  enablePivot: true,
                  aggFunc: "sum",
                  cellRenderer: CurrencyCell,
                  type: "rightAligned",
                  enableValue: true,
                },
              //   {
              //     headerClass: "primary",
              //     headerName: "Qty",
              //     field: "M-1 Discount Visibility Act Quantity",
              //     width: 120,
              //     enablePivot: true,
              //     aggFunc: "sum",
              //     //...(type === "Quantity" && { aggFunc: "sum" }),
              //     cellRenderer: CurrencyCell,
              //     type: "rightAligned",
              //     enableValue: true,
              //   },
              ],
            },
          ],
        },
      ],
    },
  ];
};
